import { FileManagerTypes } from '../constants/filemanagerConstants';

const openWindow = (mode = 'single', callback= ()=>{}) => ({
    type: FileManagerTypes.OPEN_CLOSE_WINDOW,
    opened: true,
    mode,
    callback
});

const closeWindow = () => ({
    type: FileManagerTypes.OPEN_CLOSE_WINDOW,
    opened: false
});

const setFiles = (files) => ({
    type: FileManagerTypes.SET_FILES,
    files
});

export default {
    openWindow,
    closeWindow,
    setFiles
};